import { useQuery } from '@tanstack/react-query'

import { fetchDomainValidation } from 'utils/api/domain'

type ReturnType = {
  domainValidation: DomainValidation | undefined
  isLoading: boolean
  isFetching: boolean
  refetch: () => void
  error: Error | null
}

type UseValidateDomainProps = {
  companyId: string
  url: string
  isAccessible?: boolean
  isValidGscDomain?: boolean
  isQueryEnabled: boolean
}

export const useValidateDomain = ({
  companyId,
  url,
  isAccessible = false,
  isValidGscDomain = false,
  isQueryEnabled,
}: UseValidateDomainProps): ReturnType => {
  const handleApiRequest = async () => {
    const response = await fetchDomainValidation({
      companyId,
      url,
      isAccessible,
      isValidGscDomain,
    })
    if (response.status === 'error') {
      throw new Error(response.error)
    }
    return response.data
  }

  const { isLoading, isFetching, error, refetch, data } = useQuery<
    DomainValidation,
    Error
  >({
    queryKey: [`domain-validation-${url}`, companyId],
    queryFn: handleApiRequest,
    enabled: isQueryEnabled,
  })

  return {
    domainValidation: data,
    isLoading,
    isFetching,
    refetch,
    error,
  }
}
